import React from 'react';


const PerformanceComparisonChart = ({ data, selectedAgents, metric }) => {
  const agentColors = {
    'agent-001': '#1E3A8A',
    'agent-002': '#0F766E',
    'agent-003': '#D97706',
    'agent-004': '#DC2626',
    'agent-005': '#7C3AED'
  };

  const metricLabels = {
    resolution: 'Resolution Rate (%)',
    handleTime: 'Avg Call Time (min)',
    kbUsage: 'KB Utilization (%)'
  };

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-popover border border-border rounded-lg p-3 shadow-lg">
          <p className="text-sm font-medium text-foreground mb-2">{label}</p>
          {payload?.map((entry, index) =>
          <div key={index} className="flex items-center justify-between gap-4 text-xs">
              <span style={{ color: entry?.color }}>{entry?.name}:</span>
              <span className="font-semibold text-foreground">{entry?.value}</span>
            </div>
          )}
        </div>);

    }
    return null;
  };

  return;


















































};

export default PerformanceComparisonChart;